import { render, staticRenderFns } from "./DetailsInformationArg.vue?vue&type=template&id=4e569b36&"
import script from "./DetailsInformationArg.vue?vue&type=script&lang=js&"
export * from "./DetailsInformationArg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports